import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			homeResultsContentSectionInnerCls: string;
		}
	},

	slug: string
}

class Results extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home Results Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeResultsContentSectionInnerCls || '', 'home_results', { animCls: 'animate__slideInLeft', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Results;